<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-modal id="visualizar-modal" v-model="showModal"> </b-modal>

                <b-form-row @keyup.enter="load">
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" @change="load" />
                    </b-col>
                    <b-col lg="6" sm="10" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                    </b-col>
                    <b-col cols="4" class="text-right mt-2">
                        <b-button id="btnPesquisar" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <b-tooltip :target="'btnPesquisar'" title="Localizar"></b-tooltip>
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                        </b-button>
                        <b-button id="sincronizar" class="mr-2 my-2" size="sm" pill variant="primary"
                            @click="desenvolvimento" style="height: 30px">
                            <div>
                                <b-icon icon="arrow-clockwise" />&nbsp; Sincronizar
                            </div>
                            <b-tooltip title="Sincronizar dados com o Senado..." target="sincronizar"></b-tooltip>

                        </b-button>

                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :filter="filtro" :hover="true"
                    @row-dblclicked="unidadeAdministrativaSelect" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template #empty>
                        <p>
                            Nenhum Registro encontrado
                        </p>
                    </template>


                    <template v-slot:cell(pertenceAlmoxarifado)="row">
                        <b-button :id="row.index + 'pertenceAlmoxarifado'" class="my-2" size="sm" pill
                            variant="primary">
                            <b-tooltip :target="row.index + 'pertenceAlmoxarifado'" title="Almoxarifado"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(pertencePatrimonio)="row">
                        <b-button :id="row.index + 'pertencePatrimonio'" class="my-2" size="sm" pill variant="primary">
                            <b-tooltip :target="row.index + 'pertencePatrimonio'" title="Patrimonio"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(configAlmoxarifado)="row">
                        <b-button :id="row.index + 'configAlmoxarifado'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalModulo(row.item)">
                            <b-icon icon="gear" />
                            <b-tooltip :target="row.index + 'configAlmoxarifado'"
                                title="Configurar módulos..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switch-departmaneto-sgu'">
                            <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)"
                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switch-departmaneto-sgu'"
                                title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ConfiguracaoModulo v-if="showModalModulo" @close="fecharModalModulo" :departamento="departamento" :prefix="prefix + title + ' > '" ></ConfiguracaoModulo>
    </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import ResourceService from "@/core/api/ResourceService";
import ConfiguracaoModulo from "./ConfiguracaoModulo.vue";

export default {
    name: "DepartamentoSguList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        ConfiguracaoModulo
    },

    props: {
        onDblClickUnidadeAdministrativa: Function,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Unidade Administrativa",
        },
    },

    data() {
        return {
            departamento:{},
            showModalModulo: false,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},
            showModal: false,
            records: [],
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService("/api/sgu/departamentos");
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "sigla",
                    label: "Sigla",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "nome",
                    label: "Nome Unidade Administrativa",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "configAlmoxarifado",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "configLocalizacao",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    methods: {
        fecharModalModulo(){
            this.departamento = {};
            this.showModalModulo = false;

        },
        abrirModalModulo(item){
            this.departamento = item;
            this.showModalModulo = true;

        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Unidade Administrativa?",
                item.nome.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

        async load() {
            this.filtro = {};
            if (this.form.descricao && this.form.descricao != "") {
                this.filtro.descricao = this.form.descricao;
            }
            this.filtro.situacao = null;
            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao;
            }

            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });

        },

        desenvolvimento() {
            this.$bvToast.toast("Em desenvolvimento...", {
                title: "Aviso",
                variant: "warning",
                solid: true,
            })
        },

        clearForm() {
            this.form.descricao = ""
            this.form.situacao = "1"
            this.load()
        },

        async visualizarResource() {
            this.showModal = true
        },

        async unidadeAdministrativaSelect(item) {
            this.$emit("onDblClickUnidadeAdministrativa", item)
        },
    },
}
</script>
